import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {CompanyType} from '../../models/user/user';

@Component({
    selector: 'app-publish-tis-version-modal',
    templateUrl: './publish-tis-version-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublishTisModalComponent {
    public modalConfig = inject<VwuiModalConfig<{ companyType: CompanyType; }>>(VwuiModalConfig);
    public modalRef = inject(VwuiModalRef);


    public loading = false;
    public companyType: CompanyType;

    constructor() {
        const modalConfig = this.modalConfig;

        this.companyType = modalConfig.data.companyType;
    }

    async submit() {
        this.modalRef.close(true);
    }

}
